export const normalizeCalendarType = (type) => {
    if(!type) return ''

    const normalizedMap = {
        'pick-up new wigs': 'pick_up_new',
        'pick_up_new': 'pick_up_new',
        'repairs': 'repairs',
        'pick-up repairs': 'pick_up_repairs',
        'pick_up_repairs': 'pick_up_repairs',
        'us agent': 'us_agent',
        'us_agent': 'us_agent',
        'orders': 'orders',
    }

    const lower = type.toLowerCase()
    return normalizedMap[lower] || lower
}